export const moreThanZeroLabel = "> 0";
